import React, { useState, useEffect } from "react";
import API from "../../../../api";

const ContentDetail = ({ message }) => {
  const [isWaitingForResponse, setIsWaitingForResponse] = useState(false);
  const [waitingMessage, setWaitingMessage] = useState('');
  const [msg, setMsg] = useState("");
  const [displayedMsg, setDisplayedMsg] = useState("");

  useEffect(() => {
    let intervalId;
  
    if (isWaitingForResponse) {
      const dots = ['', '.', '..', '...'];
      let index = 0;
  
      intervalId = setInterval(() => {
        setWaitingMessage(`Tires-IA is analyzing${dots[index]}`);
        index = (index + 1) % dots.length;
      }, 500); // Cambia i puntini ogni 500 millisecondi
    } else {
      setWaitingMessage('');
    }
  
    return () => clearInterval(intervalId); // Pulizia dell'intervallo al cambio di stato o smontaggio
  }, [isWaitingForResponse]);

  const processMessage = async (message) => {
    try {
      setDisplayedMsg("");
      const res = await API.chatBotAI({ message: message });
      if (res.data) {
        setMsg(res.data);
      }
    } catch (error) {
      console.error("[processMessage] Error processing message:", error);
    }
  };

  useEffect(() => {
    processMessage(message);
  }, [message]);

  useEffect(() => {
    setIsWaitingForResponse(!msg);
    if (!msg) return;

    let i = 0, intervalId = setInterval(() => {
      setDisplayedMsg(p => p + msg[i++]);
      if (i >= msg.length) clearInterval(intervalId);
    }, 20);

    return () => clearInterval(intervalId);
  }, [msg]);



  return (
    <div>
      {isWaitingForResponse && <div>{waitingMessage}</div>}
      {!isWaitingForResponse && displayedMsg !== "" && (
        <div className="tiresia-chat">{displayedMsg}</div>
      )}

    </div>
  );

};

export default ContentDetail;
